import store from '../redux/store';
import { handleJoiSchemaError, getCompanyIdFromDomain } from '../utils';
import { logMediumError } from '../utils/logger';
import { API_SHOP_ADDRESS, API_SHOPS } from './api';
import { sendGetRequest } from './backend';

export const getAllShops = async () => {
  const configurationReducer = store.getState().configurationReducer;
  const companyId = configurationReducer?.companyId ?? getCompanyIdFromDomain();
  try {
    const response = await sendGetRequest(API_SHOPS(companyId), null, false);

    return response.data;
  } catch (error) {
    logMediumError(
      `Failed to get all shop from company (${companyId})  ${handleJoiSchemaError(
        error
      )}`
    );
  }
};

export const getShopAddress = async (shopId: string) => {
  const configurationReducer = store.getState().configurationReducer;
  const companyId = configurationReducer?.companyId ?? getCompanyIdFromDomain();
  try {
    const response = await sendGetRequest(
      API_SHOP_ADDRESS(companyId, shopId),
      null,
      false
    );

    return response.data;
  } catch (error) {
    logMediumError(
      `Failed to get shop (${shopId}) address from company (${companyId})  ${handleJoiSchemaError(
        error
      )}`
    );
  }
};
